import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import { HttpParams } from '@angular/common/http';
import Swal from 'sweetalert2'
import { Router } from '@angular/router';

@Component({
    selector: 'app-store',
    templateUrl: './store.component.html',
    styleUrls: ['./store.component.css'],
    standalone: false
})
export class StoreComponent implements OnInit {

  page = 1;
  pageSize = 10;
  list_length = 0;

  token: any;
  items: any[] = [];
  products: any[] = [];
  patients: any[] = [];

  employeeName: any;
  filter_config: any;

  bill = {
    sub_total: 0,
    total: 0,
    vat_total: 0,
    discount_total: 0,
    vat: 0,
    discount: 0,
    method: null
  }

  patient: any = {
    name: '',
    number: ''
  }

  today: any;
  customer_keyword: any;

  constructor(public utility: UtilitiesService, private api: ApiService, private modalService: NgbModal, private router: Router) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
    this.filter_config = {
      itemsPerPage: 1000,
      currentPage: 1,
      totalItems: 0,
      sort: null,
      sort_order: 'asc',
      pageSizeOptions: [5, 10, 25, 100]
    };
  }

  ngOnInit() {
    this.getItems();
  }


  getHttpParams() {
    let params = new HttpParams();
    params = params.append('page', this.filter_config.currentPage.toString());
    params = params.append('per_page', this.filter_config.itemsPerPage.toString());
    if (this.filter_config.sort) {
      params = params.append('sort', this.filter_config.sort);
      params = params.append('sort_order', this.filter_config.sort_order);
    }
    if (this.filter_config.queries) {
      params = params.append('queries', this.filter_config.queries);
    }
    return params;
  }

  getItems(id?: any) {
    this.utility.loading = true;
    const sub = this.api.get('items/', this.token, { params: this.getHttpParams() }).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
        this.products = objects.items;

        this.products.forEach((item) => {
          item.isOrangeBorder = false;
        })
      },
      async error => { }
    );
    sub.add(() => { this.getPatients() });
  }

  async getPatients() {
    const sub = this.api.get('patients/', this.token).subscribe(
      async data => {

        let objects: any = {}
        objects = data;

        this.patients = objects;

        this.patients.forEach((patient) => {
          patient.name = patient.first_name + ' ' + patient.last_name;
        })
      },
      async error => { }
    );

    sub.add(() => { this.utility.loading = false; });
  }

  filterFunction(items: any[]) {
    if (this.employeeName == null)
      return items;
    else
      return items.filter(i => i.name.toLowerCase().indexOf(this.employeeName.toLowerCase()) >= 0 || i.phone.toString() === this.employeeName.toLowerCase());
  }

  selectCustomer() {
    this.patient = this.patient;
  }

  async toggleProduct(product: any) {
    //product.isOrangeBorder = !product.isOrangeBorder; // Toggle border selection

    let item: any = {
      id: product?.id,
      service_name: product?.name,
      quantity: 0,
      final_price: 0,
      unit: 'piece',
      service_price: product?.price
    };
    //item = product;

    let title = 'Please type number of pieces';
    if (product?.quantity > 0) {
      const { value: number_ } = await Swal.fire({
        title: title,
        input: "text",
        // inputLabel: "Some values",
        inputPlaceholder: "quantity value ..."
      });
      if (number_) {
        if (product?.quantity >= number_) {
          item.quantity = number_;
          item.final_price = +number_ * +product?.price;

          this.items.push(item);
          this.bill.sub_total += item.final_price;
          this.bill.vat_total = (this.bill.sub_total * (this.bill.vat / 100));
          this.bill.total = (this.bill.sub_total + this.bill.vat_total) - this.bill.discount_total;

          product.isOrangeBorder = true;
        }
        else {
          let title = 'Please check qunaitiy not exceeding the stock!';
          Swal.fire({
            text: title,
            icon: 'warning',
            confirmButtonText: 'Ok'
          })
        }
      }
    }
    else {
      let title = 'There is no Quantity for this product!';
      Swal.fire({
        text: title,
        icon: 'warning',
        confirmButtonText: 'Ok'
      })
    }
  }

  removeItem(item: any) {
    const index = this.items.findIndex(i => i.service_name === item.service_name);
    if (index !== -1) {
      this.bill.sub_total -= item.final_price;
      this.bill.vat_total = (this.bill.sub_total * (this.bill.vat / 100));
      this.bill.total = (this.bill.sub_total + this.bill.vat_total) - this.bill.discount_total;

      this.items.splice(index, 1);

      let _item = null;

      _item = this.products.find(i => i.id === item.id);

      _item.isOrangeBorder = false;
    }
  }

  cal_discount() {
    this.bill.discount_total = this.bill.sub_total * (this.bill.discount / 100);

    this.get_total();
  }

  get_total() {
    this.bill.total = (this.bill.sub_total + this.bill.vat_total) - this.bill.discount_total;
  }

  select_payment(type: any) {
    this.bill.method = type;
  }

  cancel() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  sucess() {
    Swal.fire({
      title: 'Success!',
      text: 'Successfully added!',
      icon: 'success',
      confirmButtonText: 'Ok'
    })

    // reload the route to refresh the content ...
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });

    this.modalService.dismissAll();
    this.utility.loading = false;
  }

  async make_payment() {
    if (this.patient) {
      this.utility.loading = true;

      let details: any = {};
      let patient_ = {
        patient_name: this.patient.name,
        patient_number: null,
        patient_phone: this.patient.number,
        patient_address: null
      }

      let payment_services = {
        service_name: 'buying medical item.',
        service_price: this.bill.total,
        final_price: this.bill.total,
        quantity: this.items.length
      }

      details.patient = patient_;
      details.payment_services = this.items;

      const body = {
        appointment_id: null,
        client_id: null,
        final_price: this.bill.total,
        service_price: this.bill.total,
        payment_type: this.bill.method,
        is_package: false,
        package_paid_amount: 0,
        payment_details: details
      }

      const sub = this.api.post("payments/", body, this.token).subscribe(
        async data => {
          // success message ...
          let objects: any = {}
          objects = data;

          let id = objects.id;

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Payment Created Successfully'
          })

          this.items.forEach((item) => {
            this.update_item_quantity(item);
          });

          this.router.navigate([]).then(result => { window.open('invoice_print?id=' + id, '_blank'); });
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
      sub.add(() => { this.utility.loading = false; })
    }
    else {
      let title = 'Please add patient details';
      Swal.fire({
        text: title,
        icon: 'warning',
        confirmButtonText: 'Ok'
      })
    }
  }

  update_item_quantity(item: any) {
    let body = { 'paid_quantity': +item.quantity }
    this.api.update("items/quantity/" + item.id, body, this.token).subscribe(
      async data => { }
    );
  }
}
